export default __webpack_public_path__ + "static/vu-5b2499ba08a84efa8e3372e0b22d350d.svg";